<template>
  <div>
    <div class="nav-bar">
      <div
        class="nav-bar__item"
        :class="{ active: step === 'general' }"
        @click="changeTab('general')"
      >
        Общее
      </div>
      <div
        class="nav-bar__item"
        :class="{ active: step === 'results' }"
        @click="changeTab('results')"
      >
        Результаты
      </div>
      <div
        class="nav-bar__item"
        :class="{ active: step === 'members' }"
        @click="changeTab('members')"
      >
        Участники
      </div>
      <div
        class="nav-bar__item"
        :class="{ active: step === 'race-analyzer-v2' }"
        @click="changeTab('race-analyzer-v2')"
      >
        🏃 Анализ результатов v2
      </div>
    </div>
    <div v-if="step === 'race-analyzer-v2'">
      <race-analyzer-v2 :start-id="start.id" />
    </div>
    <div v-if="step === 'general'">
      <!-- Общая информация -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.globalInfo
          class="distance_form__button"
          @click="toggleCollapsed('globalInfo')"
        >
          <h4 class="card-title">
            Общая информация
          </h4>
          <span>{{ collapsedStates.globalInfo ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="globalInfo">
          <GeneralInfoSection
            :start="start"
            :cities="cities"
          />
        </b-collapse>
      </div>
      <!-- Форма старта -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.formStart
          class="distance_form__button"
          @click="toggleCollapsed('formStart')"
        >
          <h4 class="card-title">
            Форма старта
          </h4>
          <span>{{ collapsedStates.formStart ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="formStart">
          <div class="card card--collapse">
            <div
              v-if="Array.isArray(distancesWithFiles[0])"
              class="ml-2"
            >
              <start-days
                v-for="(day, index) in distancesWithFiles"
                v-show="index === active_day"
                :key="'sport_day_' + index"
                :age_groups="age_groups"
                :select_kinds_sport="day"
              />
            </div>

            <main-form
              v-else
              :select_kinds_sport="distancesWithFiles"
              :start="start"
              :age_groups="age_groups"
            />
          </div>
        </b-collapse>
      </div>
      <!-- Связанные старты -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.linkedStarts
          class="distance_form__button"
          @click="toggleCollapsed('linkedStarts')"
        >
          <h4 class="card-title">
            Связанные старты
          </h4>
          <span>{{ collapsedStates.linkedStarts ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="linkedStarts">
          <LinkedStarts
            v-if="startPageId"
            :all-series="allSeries"
            :start-id="startPageId"
            @update:allSeries="allSeries = $event"
          />
          <div v-else>
            Информация подгружается...
          </div>
        </b-collapse>
      </div>
      <!-- Архивы -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.linkedArchives
          class="distance_form__button"
          @click="toggleCollapsed('linkedArchives')"
        >
          <h4 class="card-title">
            Архивы
          </h4>
          <span>{{ collapsedStates.linkedArchives ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="linkedArchives">
          <LinkedArchives
            v-if="startPageId"
            :all-archives="allArchives"
            :start-id="startPageId"
            @update:allArchives="allArchives = $event"
            @archive-changed="onStartArchiveChanged"
          />
          <div v-else>
            Информация подгружается...
          </div>
        </b-collapse>
      </div>
      <!-- Афиша старта -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.afishaStart
          class="distance_form__button"
          @click="toggleCollapsed('afishaStart')"
        >
          <h4 class="card-title">
            Афиша старта
          </h4>
          <span>{{ collapsedStates.afishaStart ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="afishaStart">
          <StartImagesSection v-model="start" />
        </b-collapse>
      </div>
      <!-- Полезные ссылки -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.usefullLinks
          class="distance_form__button"
          @click="toggleCollapsed('usefullLinks')"
        >
          <h4 class="card-title">
            Полезные ссылки
          </h4>
          <span>{{ collapsedStates.usefullLinks ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="usefullLinks">
          <UsefullLinksSection
            :useful_links.sync="useful_links"
            :socials.sync="socials"
          />
        </b-collapse>
      </div>
      <!-- Организаторы -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.organizators
          class="distance_form__button"
          @click="toggleCollapsed('organizators')"
        >
          <h4 class="card-title">
            Организаторы
          </h4>
          <span>{{ collapsedStates.organizators ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="organizators">
          <OrganizersStartSection
            :organizers.sync="organizers"
            :main-organizer-index.sync="mainOrganizerIndex"
          />
        </b-collapse>
      </div>
      <!-- Описание -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.description
          class="distance_form__button"
          @click="toggleCollapsed('description')"
        >
          <h4 class="card-title">
            Описание старта
          </h4>
          <span>{{ collapsedStates.description ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="description">
          <div class="card">
            <div class="card-header" />
            <div class="card-body">
              <div class="my-1">
                Полное описание
              </div>
              <quill-editor
                ref="myQuillEditor1"
                v-model="start.description"
                @change="onEditorChange($event)"
              />
              <div class="my-1 mt-5">
                Краткое описание
              </div>
              <quill-editor
                ref="myQuillEditor2"
                v-model="start.condition_short"
                @change="onEditorChange($event)"
              />
            </div>
          </div>
        </b-collapse>
      </div>
      <!-- Описание регламента -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.reglament
          class="distance_form__button"
          @click="toggleCollapsed('reglament')"
        >
          <h4 class="card-title">
            Описание регламента
          </h4>
          <span>{{ collapsedStates.reglament ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="reglament">
          <div class="card">
            <div class="card-body">
              <div class="my-1">
                Полное описание
              </div>
              <quill-editor
                ref="myQuillEditor3"
                v-model="start.regulation"
                @change="onEditorChange($event)"
              />
            </div>
          </div>
        </b-collapse>
      </div>
      <!-- Описание положения -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.extractStatement
          class="distance_form__button"
          @click="toggleCollapsed('extractStatement')"
        >
          <h4 class="card-title">
            Описание положения
          </h4>
          <span>{{ collapsedStates.extractStatement ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="extractStatement">
          <div class="card">
            <div class="card-body">
              <div class="my-1">
                Полное описание
              </div>
              <quill-editor
                ref="myQuillEditor4"
                v-model="start.extract_statement"
                @change="onEditorChange($event)"
              />
            </div>
          </div>
        </b-collapse>
      </div>
      <!-- Спонсоры -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.sponsors
          class="distance_form__button"
          @click="toggleCollapsed('sponsors')"
        >
          <h4 class="card-title">
            Спонсоры
          </h4>
          <span>{{ collapsedStates.sponsors ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="sponsors">
          <SponsorsSection :sponsors.sync="sponsors" />
        </b-collapse>
      </div>
      <!-- Схема проезда -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.schemeRoute
          class="distance_form__button"
          @click="toggleCollapsed('schemeRoute')"
        >
          <h4 class="card-title">
            Схема проезда
          </h4>
          <span>{{ collapsedStates.schemeRoute ? '🔼' : '🔽' }}</span>
        </div>

        <b-collapse id="schemeRoute">
          <SchemeRouteSection
            :scheme-route-file.sync="start.template_frame_image"
            :scheme-route-file-id.sync="schemeRouteFileId"
            :scheme-route-iframe.sync="schemeRouteIframe"
            :show-iframe-preview.sync="showIframePreview"
          />
        </b-collapse>
      </div>
      <!-- Программа старта -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.programmOfStart
          class="distance_form__button"
          @click="toggleCollapsed('programmOfStart')"
        >
          <h4 class="card-title">
            Программа старта
          </h4>
          <span>{{ collapsedStates.programmOfStart ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="programmOfStart">
          <ProgramOfStartSection
            :start.sync="start"
            :config="config"
          />
        </b-collapse>
      </div>
      <!-- Промокоды -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.promocodes
          class="distance_form__button"
          @click="toggleCollapsed('promocodes')"
        >
          <h4 class="card-title">
            Промокоды
          </h4>
          <span>{{ collapsedStates.promocodes ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="promocodes">
          <PromocodesSection
            :promo-codes.sync="promocodes"
            @delete-promocode="deletePromocode"
            @add-from-template="addPromosFromTemplate"
          />
        </b-collapse>
      </div>
      <!-- Персональные скидки -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.personalDiscounts
          class="distance_form__button"
          @click="toggleCollapsed('personalDiscounts')"
        >
          <h4 class="card-title">
            Персональные скидки
          </h4>
          <span>{{ collapsedStates.personalDiscounts ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="personalDiscounts">
          <PersonalDiscountsSection
            :personal-discounts.sync="personalDiscounts"
            :user-options="ddUsers"
            @search-users="onSearch"
            @delete-discount="deletePersonalDiscount"
            @add-from-template="addPersonalDiscountsFromTemplate"
          />
        </b-collapse>
      </div>
      <!-- Фильтрация -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.filters
          class="distance_form__button"
          @click="toggleCollapsed('filters')"
        >
          <h4 class="card-title">
            Фильтрация
          </h4>
          <span>{{ collapsedStates.filters ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="filters">
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Виды спорта" />
                  <v-select
                    v-model="kindOfSports_local"
                    multiple
                    :reduce="e => e.id"
                    label="name"
                    :options="kindOfSports"
                    append-to-body
                  />
                </b-col>
                <b-col md="6">
                  <b-form-group label="Сезон" />
                  <b-form-select
                    v-model="start.season_id"
                    :options="seasons"
                    text-field="name"
                    value-field="id"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-collapse>
      </div>
      <!-- Правила возврата -->
      <div
        v-if="startPageId"
        class="collapse-wrapper"
      >
        <div
          v-b-toggle.refundRules
          class="distance_form__button"
          @click="toggleCollapsed('refundRules')"
        >
          <h4 class="card-title">
            Правила возврата
          </h4>
          <span>{{ collapsedStates.refundRules ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="refundRules">
          <RefundRulesSection :start-id="startPageId" />
        </b-collapse>
      </div>
      <!-- Страница старта: гид, программа, FAQ, обновления -->
      <div
        v-if="startPageId"
        class="collapse-wrapper"
      >
        <div
          v-b-toggle.startInfo
          class="distance_form__button"
          @click="toggleCollapsed('startInfo')"
        >
          <h4 class="card-title">
            Страница старта: гид, программа, FAQ, обновления
          </h4>
          <span>{{ collapsedStates.startInfo ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="startInfo">
          <StartInfoSection :start-id="startPageId" />
        </b-collapse>
      </div>
      <!-- Банковская статистика -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.bankStatistic
          class="distance_form__button"
          @click="toggleCollapsed('bankStatistic')"
        >
          <h4 class="card-title">
            Банковская статистика
          </h4>
          <span>{{ collapsedStates.bankStatistic ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="bankStatistic">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">
                Банковская статистика
              </h4>
            </div>
            <div class="card-body">
              <start-statistic :start-id="+$route.params.id" />
            </div>
          </div>
        </b-collapse>
      </div>
      <!-- Отзывы -->
      <div class="collapse-wrapper">
        <div
          v-b-toggle.reviews
          class="distance_form__button"
          @click="toggleCollapsed('reviews')"
        >
          <h4 class="card-title">
            Отзывы
          </h4>
          <span>{{ collapsedStates.reviews ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="reviews">
          <div class="card">
            <div class="card-body">
              <p class="mb-3 text-muted small">
                Выберите критерии оценки (от 0 до 10), которые будут доступны участникам для данного старта:
              </p>
              <div
                v-for="(criterion, index) in allCriteria"
                :key="'criterion-' + index"
                class="criterion-item"
              >
                <b-form-checkbox
                  v-model="selectedCriteriaKeys"
                  :value="criterion.title"
                >
                  <div class="criterion-content">
                    <span class="criterion-title">{{ criterion.title }}</span>
                    <span
                      v-if="criterion.description"
                      class="criterion-description text-muted"
                    >
                      — {{ criterion.description }}
                    </span>
                  </div>
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div v-if="step === 'results'">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Результаты старта
          </h4>
        </div>
        <div class="card-body">
          <div
            v-for="(result, index) in start.results"
            :key="'result-link' + index"
          >
            <b-button
              variant="primary"
              size="sm"
              class="mb-1"
              @click="start.results.splice(index, 1)"
            >Удалить
            </b-button>
            <file-uploader
              v-model="result.fileID"
              :default="result.file"
              :title="'Файл ' + (index + 1)"
            />
            <b-form-input
              v-model="result.name"
              class="links__input"
              placeholder="Название файла"
            />
          </div>
          <b-button
            variant="primary"
            class="mr-1"
            @click="addResultLink"
          >Добавить результат
          </b-button>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Загрузка результатов Excel
          </h4>
        </div>
        <div class="card-body">
          <div
            v-for="(column, ind) in excelResultColumns"
            :key="'excel_column_' + ind"
          >
            <b-form-group :label="'Circle' + (ind + 1)">
              <b-form-input
                v-model="column.value"
                class="links__input"
                placeholder="Название колонки"
              />
              <b-button
                variant="primary"
                size="sm"
                class="mb-1"
                @click="excelResultColumns.splice(ind, 1)"
              >Удалить
              </b-button>
            </b-form-group>
          </div>
          <b-button
            variant="primary"
            class="mb-5"
            @click="excelResultColumns.push({ value: '' })"
          >Добавить название
            колонки
          </b-button>

          <b-form-group label="Забеги">
            <div
              v-for="(run, index) in runs"
              :key="'run' + index"
            >
              <div class="links">
                <b-col md="6">
                  <div class="flex-wrapper">
                    <svg
                      width="16"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="minus"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      class="svg-inline--fa fa-minus fa-w-14"
                      @click="deleteRun(index)"
                    >
                      <path
                        d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                        class=""
                      />
                    </svg>
                    <b-form-input
                      v-model="run.name"
                      placeholder="Название"
                      class="links__input"
                    />
                  </div>
                </b-col>

                <b-col md="6">
                  <flat-pickr
                    v-model="run.time"
                    placeholder="Дата"
                    class="form-control"
                    :config="config"
                  />
                </b-col>
              </div>
            </div>

            <b-button
              variant="primary"
              class="mr-1"
              @click="addRun()"
            >
              Добавить забег
            </b-button>
          </b-form-group>

          <excel-uploader
            :on-success="successResultUpload"
            :runs="runs"
          />
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Результаты из файла
          </h4>
        </div>
        <div class="card-body">
          <start-members-results
            ref="fileResultsComponent"
            :start_id="$route.params.id"
            :columns="excelResultColumns"
          />
        </div>
      </div>
    </div>
    <div v-if="step === 'members'">
      <additional-field-change-requests-queue
        :start-id="Number($route.params.id)"
        class="mb-2"
        @updated="getMembersFromStart"
      />
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Зарегистрированные участники
          </h4>
        </div>
        <div class="card-body">
          <div>
            <b-modal
              id="modal-2"
              ref="delete-modal"
              title="Удалить регистрацию"
              cancel-title="Отмена"
              ok-title="Удалить"
              @ok="deleteRegistration"
            >
              <p>
                Вы уверены, что хотите удалить регистрацию и все данные о её
                участниках? Это действие нельзя будет отменить.
              </p>
            </b-modal>
            <b-modal
              id="modal-bulk-delete-registrations"
              ref="bulk-delete-modal"
              title="Удалить выбранные регистрации"
              cancel-title="Отмена"
              ok-title="Удалить"
              ok-variant="danger"
              :ok-disabled="bulkDeleteLoading"
              :cancel-disabled="bulkDeleteLoading"
              :no-close-on-backdrop="bulkDeleteLoading"
              :no-close-on-esc="bulkDeleteLoading"
              :hide-header-close="bulkDeleteLoading"
              @ok="deleteBulkRegistrations"
            >
              <p>
                Вы уверены, что хотите удалить выбранные регистрации
                ({{ selectedGroups.length }} шт.) и все данные об участниках?
                Это действие нельзя будет отменить.
              </p>
            </b-modal>
            <b-modal
              id="modal-1"
              ref="edit-modal"
              title="Редактирование"
              :hide-footer="true"
            >
              <edit-member
                :member="currentMember"
                :modal-ref="$refs['edit-modal']"
                :cities="cities"
                @save="getMembersFromStart"
              />
            </b-modal>
            <b-form-group class="search-wrap">
              <div class="d-flex align-items-center">
                <b-form-input
                  v-model="searchMember"
                  placeholder="Поиск"
                  type="search"
                  class="d-inline-block"
                  @input="onMembersSearchInput"
                />
              </div>
            </b-form-group>
            <b-table
              :items="members"
              :fields="registrationFields"
              striped
              responsive
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              no-local-sorting
              :busy="membersSortLoading"
              class="first-table"
              :tbody-tr-class="getRowClass"
              @sort-changed="onMembersSortChanged"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner small class="align-middle mr-1" />
                  <strong>Сортировка...</strong>
                </div>
              </template>
              <template #cell(actions)="data">
                <div class="icons-container">
                  <b-form-checkbox
                    v-model="selectedGroups"
                    :value="data.item.id"
                  />
                  <div
                    v-b-modal.modal-2
                    @click="currentRegForDelete = data.item.id"
                  >
                    <svg
                      style="margin-right: 10px"
                      data-v-3f2fc030=""
                      fill="#7367f0"
                      width="14"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        data-v-3f2fc030=""
                        d="M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM394.8 466.1C393.2 492.3 372.3 512 346.9 512H101.1C75.75 512 54.77 492.3 53.19 466.1L31.1 128H416L394.8 466.1z"
                      />
                    </svg>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#fff"
                    :class="[
                      'bi bi-chevron-down',
                      data.detailsShowing ? 'rotate-chevron' : '',
                    ]"
                    viewBox="0 0 16 16"
                    @click="data.toggleDetails()"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    />
                  </svg>
                </div>
              </template>
              <template #cell(single_member)="data">
                {{ checkRegistrationForSingleMember(data.item.members) }}
              </template>
              <template #cell(registration_date)="data">
                {{
                  data.item.registration_date
                    ? $moment(data.item.registration_date).format('DD.MM.YYYY')
                    : 'Нет даты регистрации'
                }}
              </template>
              <template #cell(payment)="data">
                <div class="table-payment-row">
                  <member-status
                    :status="data.item.payment"
                    :index="data.item.id"
                    :success-payment-reason="data.item.success_payment_reason"
                  />
                  <b-button
                    v-if="!data.item.payment && !isSlotReturned(data.item)"
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-success"
                    class="btn-icon ml-1"
                    @click="refreshPaymentLink(data.item)"
                  >
                    <b-spinner
                      v-if="data.item.disabled"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="DollarSignIcon"
                    />
                  </b-button>
                </div>
              </template>
              <template #cell(success_payment_reason)="data">
                {{ isSlotReturned(data.item) ? '—' : data.value }}
              </template>
              <template #cell(has_ever_refunded_slot)="data">
                {{ data.item.has_ever_refunded_slot ? 'Да' : 'Нет' }}
              </template>
              <template v-slot:row-details="row">
                <b-table
                  class="second-table"
                  :items="row.item.members"
                  :fields="memberFields"
                  :tbody-tr-class="getMemberRowClass"
                >
                  <template #cell(participantAccount)="data">
                    <b-badge
                      v-if="isGreyParticipant(data.item)"
                      variant="warning"
                    >
                      Серый #{{ data.item.participant_user_id || (data.item.participant && data.item.participant.id) }}
                    </b-badge>
                    <span v-else-if="data.item.participant_user_id || (data.item.participant && data.item.participant.id)">
                      #{{ data.item.participant_user_id || data.item.participant.id }}
                    </span>
                    <span v-else>—</span>
                  </template>
                  <template #cell(actions)="data">
                    <div class="icons-container">
                      <span
                        v-b-modal.modal-1
                        @click="currentMember = data.item"
                      >
                        <svg
                          data-v-414f8174=""
                          xmlns="http://www.w3.org/2000/svg"
                          width="14px"
                          height="14px"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-edit-2"
                        >
                          <path
                            data-v-414f8174=""
                            d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                          />
                        </svg>
                      </span>
                    </div>
                  </template>
                  <template #cell(createdAt)="data">
                    {{ $moment(data.item.createdAt).format('DD.MM.YYYY') }}
                  </template>
                  <template #cell()="data">
                    <span>{{ getUserAnswer(data) }}</span>
                  </template>
                </b-table>
              </template>
            </b-table>
            <infinite-loading
              :identifier="membersInfiniteId"
              spinner="bubbles"
              @infinite="infiniteScrollMembers"
            />
            <download-start-members-modal :distances="start.distances" />
          </div>
        </div>
      </div>
    </div>
    <b-col class="buttonsContainer">
      <div
        v-if="step === 'members'"
        class="membersTabButtons"
      >
        <b-button
          variant="primary"
          :disabled="downloadDisabled"
          @click="$bvModal.show('bv-download-members-start-modal')"
        >
          <b-spinner
            v-if="downloadDisabled"
            small
          />
          {{ downloadDisabled ? 'Скачивание...' : 'Скачать Excel' }}
        </b-button>
        <b-button
          variant="primary"
          @click="changePayment('paid')"
        >
          Отметить оплаченными
        </b-button>
        <b-button
          variant="primary"
          @click="changePayment('cancel')"
        >
          Отменить оплату
        </b-button>
        <b-button
          variant="danger"
          :disabled="selectedGroups.length === 0 || bulkDeleteLoading"
          @click="$bvModal.show('modal-bulk-delete-registrations')"
        >
          <b-spinner
            v-if="bulkDeleteLoading"
            small
            class="mr-50"
          />
          {{ bulkDeleteLoading ? 'Удаление...' : 'Удалить выбранные' }}
        </b-button>
      </div>
      <div class="membersTabButtons">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          @click="backupState()"
        >
          {{ 'Резервирование' }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          @click="restoreState"
        >
          {{ 'Восстановление' }}
        </b-button>
        <b-button
          v-if="startPageId"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="button"
          variant="outline-primary"
          :disabled="previewLoading"
          @click="openClientPreview"
        >
          {{ previewLoading ? 'Открываем...' : 'Предпросмотр на сайте' }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          :disabled="isloading"
          :title="isStartCompleted ? 'Старт завершён — сохранение может быть ограничено сервером' : ''"
          @click="saveItem"
        >
          {{ 'Сохранить' }}
        </b-button>
      </div>
    </b-col>
  </div>
</template>

<script>
import {
  BButton,
  BCardText,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BRow,
  BSpinner,
  BTable,
  VBPopover,
  BFormSelect,
  BFormRadio,
  BCollapse,
  VBToggle,
  BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { Russian } from 'flatpickr/dist/l10n/ru'
import InfiniteLoading from 'vue-infinite-loading'
import _ from 'lodash'
import FileUploader from '@/global-components/FileUploader.vue'

import EditMember from '@/views/starts/EditMember.vue'
import MainForm from '@/views/starts/new-version/MainForm.vue'
import RaceAnalyzerV2 from '@/views/starts/race-analyzer-v2/index.vue'
import StartDays from './StartDays.vue'
import crudModule from '../../libs/crud_module'
import ExcelUploader from '../../global-components/ExcelUploader.vue'
import StartMembersResults from './StartMembersResults.vue'
import StartStatistic from './StartStatistic.vue'
import MemberStatus from './MemberStatus.vue'
import DownloadStartMembersModal from './DownloadStartMembersModal.vue'
import LinkedStarts from './startPage/LinkedStarts.vue'
import LinkedArchives from './startPage/LinkedArchives.vue'
import StartImagesSection from './startPage/AfishaStartSection.vue'
import OrganizersStartSection from './startPage/OrganizersStartSection.vue'
import { validateOrganizersNoDuplicates } from './startPage/organizersValidation'
import UsefullLinksSection from './startPage/UsefullLinksSection.vue'
import SponsorsSection from './startPage/SponsorsSection.vue'
import SchemeRouteSection from './startPage/SchemeRouteSection.vue'
import ProgramOfStartSection from './startPage/ProgramOfStartSection.vue'
import GeneralInfoSection from './startPage/GeneralInfoSection.vue'
import PromocodesSection from './startPage/PromoCodesSection.vue'
import PersonalDiscountsSection from './startPage/PersonalDiscountsSection.vue'
import RefundRulesSection from './startPage/RefundRulesSection.vue'
import StartInfoSection from './startPage/StartInfoSection.vue'
import AdditionalFieldChangeRequestsQueue from './startPage/AdditionalFieldChangeRequestsQueue.vue'
import config from '@core/app-config/api-config'

const startModule = crudModule({
  entity_name: 'start',
})
const memberModule = crudModule({
  entity_name: 'member-start',
})
const kindOfSports = crudModule({
  entity_name: 'kind-of-sport',
})
const seasons = crudModule({
  entity_name: 'season',
})
const cities = crudModule({
  entity_name: 'city',
})
const questions = crudModule({
  entity_name: 'member-start/extra',
})

const paymentModule = crudModule({
  entity_name: 'member-start/change-payment',
})

const usersModule = crudModule({
  entity_name: 'user',
})

const stateKeys = [
  'start',
  'sponsors',
  'organizers',
  'socials',
  'useful_links',
  'promocodes',
  'personalDiscounts',
  'kindOfSports_local',
  'select_kinds_sport',
  'excelResultColumns',
]

export default {
  name: 'StartPage',
  components: {
    RaceAnalyzerV2,
    MainForm,
    StartStatistic,
    StartMembersResults,
    ExcelUploader,
    EditMember,
    FileUploader,
    BTable,
    StartDays,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormRadio,
    BForm,
    BButton,
    BSpinner,
    BCardText,
    flatPickr,
    BCollapse,
    BFormSelect,
    BFormTextarea,
    vSelect,
    MemberStatus,
    DownloadStartMembersModal,
    InfiniteLoading,
    LinkedStarts,
    LinkedArchives,
    StartImagesSection,
    OrganizersStartSection,
    UsefullLinksSection,
    SponsorsSection,
    SchemeRouteSection,
    ProgramOfStartSection,
    GeneralInfoSection,
    PromocodesSection,
    PersonalDiscountsSection,
    RefundRulesSection,
    StartInfoSection,
    AdditionalFieldChangeRequestsQueue,
  },

  directives: {
    'b-toggle': VBToggle,
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      debounce: null,
      step: 'general',
      excelResult: null,
      members: [],
      discount: [],
      promocodes: [],
      personalDiscounts: [],
      ddUsers: [],
      currentMember: null,
      selectedGroups: [],
      age_counting: null,
      kindOfSport: null,
      kindOfSports: [],
      kindOfSports_local: [],
      seasons: [],
      cities: [],
      excelResultColumns: [],
      allSeries: [],
      allArchives: [],
      schemeRouteFile: null,
      schemeRouteFileId: null,
      schemeRouteIframe: '',
      showIframePreview: false,
      config: {
        allowInput: true,
        altFormat: 'd.m.Y H:i',
        altInput: true,
        enableTime: true,
        dateFormat: 'Z',
        locale: Russian,
      },
      sponsors: [],
      runs: [],
      age_groups: {
        male: [
          {
            age_from: '',
            age_to: '',
          },
        ],
        female: [
          {
            age_from: '',
            age_to: '',
          },
        ],
      },
      registrationFields: [
        {
          key: 'actions',
          label: 'Действия',
        },
        'id',
        {
          key: 'single_member',
          label: 'ФИО',
        },
        {
          key: 'user',
          label: 'Инициатор',
          formatter: value => (value ? `${value.surname || ''} ${value.name || ''}`.trim() || `#${value.id}` : '—'),
        },
        {
          key: 'registration_source',
          label: 'Источник',
        },
        {
          key: 'registration_date',
          label: 'Дата регистрации',
        },
        {
          key: 'price',
          label: 'Стоимость',
          sortable: true,
          formatter: value => Number(value) / 100,
        },
        {
          key: 'previous_distance_price',
          label: 'Цена пред. дистанции',
          formatter: value => (value != null ? Number(value) / 100 : '—'),
        },
        {
          key: 'purchased_price',
          label: 'Цена новой дистанции',
          formatter: value => (value != null ? Number(value) / 100 : '—'),
        },
        {
          key: 'surcharge',
          label: 'Доплата',
          formatter: value => (value != null ? Number(value) / 100 : '—'),
        },
        {
          key: 'total_paid',
          label: 'Итоговая оплата',
          formatter: value => (value != null ? Number(value) / 100 : '—'),
        },
        {
          key: 'promocode.code',
          label: 'Промо',
        },
        {
          key: 'success_payment_reason',
          label: 'Доп инфо',
        },
        {
          key: 'payment',
          label: 'Статус',
          sortable: true,
        },
        {
          key: 'has_ever_refunded_slot',
          label: 'Возврат слота',
          sortable: true,
        },
      ],
      memberFields: [
        {
          key: 'empty',
          label: '',
        },
        {
          key: 'actions',
          label: 'Действия',
        },
        'id',
        {
          key: 'name',
          label: 'Имя',
        },
        {
          key: 'surname',
          label: 'Фамилия',
        },
        {
          key: 'participantAccount',
          label: 'Аккаунт',
        },
        {
          key: 'distance_relation.name',
          label: 'Дистанция',
          sortable: true,
        },
        {
          key: 'phone',
          label: 'Телефон',
        },
        {
          key: 'gender',
          label: 'Пол',
          sortable: true,
        },
        {
          key: 'team',
          label: 'Команда',
          sortable: true,
        },
        {
          key: 'city',
          label: 'Город',
        },
        {
          key: 'age_group.name',
          label: 'Группа',
        },
        {
          key: 'hidden',
          label: 'Скрыт',
          formatter: value => (value ? '👁️‍🗨️ Скрыт' : '👁️ Видим'),
        },
      ],
      status: [
        {
          1: 'Current',
          2: 'Professional',
          3: 'Rejected',
          4: 'Resigned',
          5: 'Applied',
        },
        {
          1: 'light-primary',
          2: 'light-success',
          3: 'light-danger',
          4: 'light-warning',
          5: 'light-info',
        },
      ],
      select_kinds_sport: [],
      active_day: 0,
      isloading: false,
      previewLoading: false,
      isLegacyStart: false,
      downloadDisabled: false,
      distancesWithFiles: [],
      start: {
        city_id: null,
        season_id: null,
        isRescheduled: false,
        isClosed: false,
        is_preview_hidden: false,
      },
      organizers: [],
      mainOrganizerIndex: 0,
      useful_links: [],
      socials: [],
      sortBy: null,
      sortDesc: false,
      membersSortLoading: false,
      searchMember: '',
      editorOptions: {
        modules: {
          toolbar: true,
        },
        placeholder: 'Введите текст...',
        readOnly: false,
        theme: 'snow',
      },
      scrollState: undefined,
      skipCountMembers: 0,
      maxResultCountMembers: 20,
      membersInfiniteId: 0,
      currentRegForDelete: null,
      bulkDeleteLoading: false,
      selectedRegToDelete: null,
      templatePromos: [],
      templatePersonalDiscounts: [],
      collapsedStates: {
        globalInfo: false,
        formStart: false,
        linkedStarts: false,
        linkedArchives: false,
        afishaStart: false,
        usefullLinks: false,
        organizators: false,
        description: false,
        reglament: false,
        extractStatement: false,
        sponsors: false,
        schemeRoute: false,
        programmOfStart: false,
        promocodes: false,
        personalDiscounts: false,
        filters: false,
        refundRules: false,
        startInfo: false,
        bankStatistic: false,
        reviews: false,
      },
      allCriteria: [
        {
          title: 'Трасса и разметка',
          description: 'Интересная ли трасса, хорошая ли разметка',
        },
        {
          title: 'Площадка старта (локация)',
          description: 'Наличие парковок, логистика до места, в целом оценка объекта, без учёта работы организатора',
        },
        {
          title: 'Работа команды, волонтёров',
          description: 'Вежливость, понятность (доходчивое объяснение), скорость работы (камера хранения, регистрация), пункты питания и т.д.',
        },
        {
          title: 'Удобства и комфорт',
          description: 'Туалеты, раздевалки, камеры хранения — всё то, что зависит как от локации, так и от организатора',
        },
        {
          title: 'Стартовый пакет',
          description: 'Соотношение стоимости слота и предоставленных бонусов: питание, фото, мерч и другие бонусы',
        },
        {
          title: 'Награждение',
          description: 'Призовой фонд и деление по группам',
        },
        {
          title: 'Вероятность рекомендации друзьям',
          description: '',
        },
      ],
      selectedCriteriaKeys: [],
    }
  },
  computed: {
    startPageId() {
      const id = this.$route.params?.id
      if (!id || id === 'new') return null
      return +id
    },
    isStartCompleted() {
      return this.start?.start_status?.code === 6
    },
  },
  watch: {
    runs: {
      handler() {
        localStorage.setItem('runs', JSON.stringify(this.runs))
      },
      deep: true,
    },
    '$route.query.tab': {
      handler(value) {
        if (value) {
          this.step = value
        } else {
          this.$router.go(-1)
        }
      },
    },
    '$route.params.id': {
      async handler(newId, oldId) {
        // Реакция только при переходе между стартами (не при первой загрузке)
        if (newId && newId !== 'new' && oldId && newId !== oldId) {
          await this.updateDataFromStart()
          await this.getAllStartSeries()
          await this.getAllStartArchives()
        }
      },
    },
  },
  async created() {
    if (this.$route.query.tab) {
      this.step = this.$route.query.tab
    } else {
      this.changeTab('general')
    }
    await this.getSeasons()
    await this.getCities()
    await this.getKindOfSports()
    const startId = this.$route.params?.id
    if (!startId || startId === 'new') {
      return
    }

    await this.updateDataFromStart()
    await this.getAllStartSeries()
    await this.getAllStartArchives()
  },
  mounted() {
    if (localStorage.runs) {
      this.runs = JSON.parse(localStorage.getItem('runs'))
    }
    this.$nextTick(() => {
      if (this.$refs.myQuillEditor1) {
        this.initImagePasteHandler('myQuillEditor1')
      }
      if (this.$refs.myQuillEditor2) {
        this.initImagePasteHandler('myQuillEditor2')
      }
      if (this.$refs.myQuillEditor3) {
        this.initImagePasteHandler('myQuillEditor3')
      }
      if (this.$refs.myQuillEditor4) {
        this.initImagePasteHandler('myQuillEditor4')
      }
    })
  },
  methods: {
    isSlotReturned(item) {
      return item.success_payment_reason === 'Слот был возвращен'
    },
    buildClientStartUrl(previewToken) {
      const host = config.clientSiteHost.replace(/\/$/, '')
      const startId = this.start.slug || this.start.id || this.$route.params.id
      const url = new URL(`${host}/starts/${startId}`)

      if (previewToken) {
        url.searchParams.set('previewToken', previewToken)
      }

      return url.toString()
    },
    async openClientPreview() {
      const startId = this.start.id || this.$route.params.id
      if (!startId || startId === 'new') {
        return
      }

      this.previewLoading = true
      try {
        const { token } = await startModule.arbitraryRequest.get(`${startId}/preview-token`)
        window.open(this.buildClientStartUrl(token), '_blank')
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка',
            icon: 'AlertTriangleIcon',
            text: 'Не удалось открыть предпросмотр',
            variant: 'danger',
          },
        })
        console.error(error)
      } finally {
        this.previewLoading = false
      }
    },
    // Переключение аккордеона
    toggleCollapsed(collapseId) {
      this.collapsedStates[collapseId] = !this.collapsedStates[collapseId]
    },
    addOrganizer() {
      this.organizers.push({
        name: null,
        phone: null,
        messengers: [],
        social_networks: [{ code: null, url: null }],
      })

      if (this.organizers.length === 1) {
        this.mainOrganizerIndex = 0
      }
    },
    backupState(lsKey = 'componentState') {
      const statesToSave = {}
      stateKeys.forEach(key => {
        if (this.$data[key] !== undefined) {
          statesToSave[key] = this.$data[key]
        }
      })
      localStorage.setItem(lsKey, JSON.stringify(statesToSave))
      if (lsKey === 'componentState') {
        this.$toast.success('Данные сохранены в локальном хранилище')
      }
    },
    restoreState() {
      this.backupState('backupComponentState')
      const savedStates = localStorage.getItem('componentState')
      if (savedStates) {
        const parsedStates = JSON.parse(savedStates)
        stateKeys.forEach(key => {
          if (parsedStates[key] !== undefined) {
            this.$data[key] = parsedStates[key]
          }
        })
      }
    },
    initImagePasteHandler(editorRefName) {
      const { quill } = this.$refs[editorRefName]

      quill.on('text-change', (delta, oldDelta, source) => {
        if (source !== 'user') return

        let index = 0
        let insertedText = null

        delta.ops.forEach(op => {
          if (op.retain) {
            index += op.retain
          }
          if (op.insert && typeof op.insert === 'string') {
            insertedText = op.insert.trim()
          }
        })

        if (!insertedText) return

        const isImageUrl = /(https?:\/\/.*\.(png|jpg|jpeg|gif|webp))/i.test(
          insertedText,
        )
        if (!isImageUrl) return

        // Удаляем только вставленный текст
        quill.deleteText(index, insertedText.length, 'silent')

        // Вставляем изображение
        quill.insertEmbed(index, 'image', insertedText, 'user')

        // Ставим курсор после изображения
        quill.setSelection(index + 1, 0, 'silent')
      })
    },
    addPromosFromTemplate(promos) {
      if (this.templatePromos.length !== 0) {
        const { template_id } = this.templatePromos[0]
        this.promocodes = this.promocodes.filter(
          promo => promo.template_id !== template_id,
        )
      }
      this.templatePromos = promos
      this.promocodes = this.promocodes.concat(promos)
    },
    deletePromocode(promocode, index) {
      if (this.templatePromos.length && promocode.template_id) {
        const indexDeletedPromo = this.templatePromos.findIndex(
          item => item.template_id === promocode.template_id
            && item.id === promocode.id,
        )
        this.templatePromos.splice(indexDeletedPromo, 1)
      }
      this.promocodes.splice(index, 1)
    },
    isExternalLink(url, code) {
      try {
        const link = new URL(url)
        return link.protocol === 'http:' || link.protocol === 'https:'
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка',
            icon: 'BellIcon',
            text: `Введите адрес социальной сети ${code} в формате http или https`,
            variant: 'danger',
          },
        })
        return false
      }
    },
    addPersonalDiscountsFromTemplate({ discounts, isReplaceMode }) {
      if (isReplaceMode) {
        this.personalDiscounts = []
        this.templatePersonalDiscounts = []
      }

      const newTemplateId = discounts[0]?.template_id

      if (
        newTemplateId
        && this.templatePersonalDiscounts.some(
          t => t.template_id === newTemplateId,
        )
      ) {
        this.personalDiscounts = this.personalDiscounts.filter(
          discount => discount.template_id !== newTemplateId,
        )
      }

      this.templatePersonalDiscounts = [
        ...this.templatePersonalDiscounts,
        ...discounts,
      ]

      this.personalDiscounts = [...this.personalDiscounts, ...discounts]
    },
    deletePersonalDiscount(discount, index) {
      if (this.templatePersonalDiscounts.length && discount.template_id) {
        const indexDeletedDiscount = this.templatePersonalDiscounts.findIndex(
          item => item.template_id === discount.template_id
            && item.id === discount.id,
        )
        this.templatePersonalDiscounts.splice(indexDeletedDiscount, 1)
      }
      this.personalDiscounts.splice(index, 1)
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.search(loading, search, this)
      }
    },
    search: _.debounce((loading, search, vm) => {
      usersModule
        .fetchItems({
          email: search,
        })
        .then(res => {
          vm.ddUsers = res.data.rows
          loading(false)
        })
    }, 350),
    changeTab(tab) {
      this.$router.push({ query: { ...this.$route.query, tab } })
    },
    onEditorChange(event) {
      event.quill
    },
    toggleDetails() { },
    checkRegistrationForSingleMember(members) {
      if (!members || members.length === 0) {
        return 'Нет участников'
      }
      if (members.length > 1) {
        return 'Более одного участника'
      }

      const member = members[0] || {}
      const patronymic = member.patronymic
        || (member.participant && member.participant.patronymic)
        || (member.user && member.user.patronymic)
        || ''
      return [member.name, member.surname, patronymic].filter(Boolean).join(' ')
    },
    getMembersSortingParam() {
      const allowed = {
        payment: 'payment',
        has_ever_refunded_slot: 'has_ever_refunded_slot',
        price: 'price',
      }
      const field = allowed[this.sortBy]
      if (!field) return null
      return `${field} ${this.sortDesc ? 'DESC' : 'ASC'}`
    },
    buildMembersPayload(overrides = {}) {
      const filterText = (this.searchMember || '').trim()
      const payload = {
        start_id: this.$route.params.id,
        skipCount: this.skipCountMembers,
        maxResultCount: this.maxResultCountMembers,
        admin: 1,
        ...(filterText ? { filterText } : {}),
        ...overrides,
      }
      const sorting = this.getMembersSortingParam()
      if (sorting) payload.sorting = sorting
      return payload
    },
    async onMembersSortChanged(ctx) {
      if (ctx) {
        this.sortBy = ctx.sortBy || null
        this.sortDesc = !!ctx.sortDesc
      }
      this.skipCountMembers = 0
      this.members = []
      this.membersSortLoading = true
      try {
        const payload = this.buildMembersPayload({
          skipCount: 0,
          maxResultCount: this.maxResultCountMembers,
        })
        const res = await memberModule.fetchItems(payload)
        const rows = (res.data && res.data.rows) || []
        this.members = [...rows]
        this.skipCountMembers = rows.length
        this.resetMembersInfiniteScroll()
      } catch (e) {
        console.error(e)
      } finally {
        this.membersSortLoading = false
      }
    },
    async infiniteScrollMembers($state) {
      this.scrollState = $state
      const payload = this.buildMembersPayload()
      await memberModule
        .fetchItems(payload)
        .then(res => {
          if (res.data.rows.length > 0) {
            this.members.push(...res.data.rows)
            this.skipCountMembers += this.maxResultCountMembers
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(err => {
          console.log(err)
          $state.complete()
        })
    },
    async updateDataFromStart() {
      const startId = this.$route.params?.id
      if (!startId || startId === 'new') {
        return
      }
      try {
        const results = await Promise.allSettled([
          startModule.fetchItem(`admin/${startId}`),
          startModule.arbitraryRequest.get(
            `${startId}/personal-discounts`,
          ),
          this.$http.get(`start/${startId}/distances`),
        ])

        const [startDataResult, personalDiscountsResult, distancesResult] = results

        if (startDataResult.status === 'fulfilled') {
          const responseData = startDataResult.value.data
          // Старые старты приходят обёрнутыми в { start_data: {...} }
          this.isLegacyStart = !!responseData.start_data
          this.start = responseData.start_data || responseData
          if (!this.start.id) {
            this.$set(this.start, 'id', +startId)
          }
        } else {
          console.error('Ошибка получения startData:', startDataResult.reason)
        }

        // Восстанавливаем локальные переменные схемы проезда из start
        if (this.start?.frame) {
          this.schemeRouteIframe = this.start.frame
        }

        if (this.start?.template_frame_image) {
          // Если template_frame_image - объект, извлекаем ID
          if (typeof this.start.template_frame_image === 'object' && this.start.template_frame_image?.id) {
            this.schemeRouteFileId = this.start.template_frame_image.id
            this.schemeRouteFile = this.start.template_frame_image
          } else {
            // Иначе это уже ID
            this.schemeRouteFileId = this.start.template_frame_image
            this.schemeRouteFile = this.start.template_frame_image
          }
        } else {
          // Если template_frame_image пустое, очищаем локальные переменные
          this.schemeRouteFileId = null
          this.schemeRouteFile = null
        }

        if (personalDiscountsResult.status === 'fulfilled') {
          this.personalDiscounts = personalDiscountsResult.value
        } else {
          console.error(
            'Ошибка получения personalDiscounts:',
            personalDiscountsResult.reason,
          )
        }

        if (distancesResult.status === 'fulfilled') {
          const distancesPayload = distancesResult.value.data
          const distances = Array.isArray(distancesPayload)
            ? distancesPayload
            : (distancesPayload?.distances || [])
          this.select_kinds_sport = distances
          this.distancesWithFiles = distances
        } else {
          console.error(
            'Ошибка получения distancesResult:',
            distancesResult.reason,
          )
        }

        if (this.start.sponsors && this.start.sponsors.length > 0) {
          this.start.sponsors.forEach(sponsor => {
            if (sponsor.logo && typeof sponsor.logo === 'string') {
              try {
                sponsor.logo = JSON.parse(sponsor.logo)
              } catch {
                sponsor.logo = null
              }
            }
          })

          this.sponsors = this.start.sponsors
        }
        if (this.start.age_counting) {
          this.age_counting = this.start.age_counting
        }
        if (
          this.start.social_networks
          && this.start.social_networks.length > 0
        ) {
          this.socials = this.start.social_networks
        }
        if (this.start.discount && this.start.discount.length > 0) {
          this.discount = this.start.discount
        }
        if (this.start.promocodes && this.start.promocodes.length > 0) {
          this.promocodes = this.start.promocodes
        }
        if (this.start.useful_links && this.start.useful_links.length > 0) {
          this.useful_links = this.start.useful_links
        }
        if (this.start.kindOfSports && this.start.kindOfSports.length > 0) {
          this.kindOfSports_local = this.start.kindOfSports.map(e => e.id)
        }
        if (this.start.organizers && this.start.organizers.length > 0) {
          this.start.organizers.forEach(org => {
            org.messengers = Array.isArray(org.messengers)
              ? org.messengers
              : (org.messengers ? org.messengers.split(',') : [])
            org.social_networks = org.social_networks && org.social_networks.length > 0
              ? org.social_networks
              : [{ code: null, url: null }]
          })
          this.organizers = this.start.organizers
          const mainIndex = this.organizers.findIndex(o => o.organizer_is_main === true || o.is_main === true)
          this.mainOrganizerIndex = mainIndex !== -1 ? mainIndex : 0
        }

        if (this.start.result_columns_json) {
          this.excelResultColumns = JSON.parse(this.start.result_columns_json)
        }

        this.selectedCriteriaKeys = []
        const criteriaSource = this.start.criteria ?? this.start.criteria_list
        if (criteriaSource) {
          try {
            const parsed = typeof criteriaSource === 'string'
              ? JSON.parse(criteriaSource)
              : criteriaSource
            if (Array.isArray(parsed) && parsed.length > 0) {
              this.selectedCriteriaKeys = parsed.map(c => c.title)
            }
          } catch {
            // invalid JSON — keep empty list
          }
        }

        await this.getQuestions()
        if (this.start.registrationsCount) {
          this.start.disabledDistances = JSON.parse(
            JSON.stringify(this.start.distances),
          )
        }
      } catch (e) {
        console.error('[updateDataFromStart] Ошибка:', e)
      }
    },
    async getDistanceses() {
      const startId = this.$route.params?.id || this.start?.id
      if (!startId || startId === 'new') {
        return
      }
      try {
        const { data } = await this.$http.get(`start/${startId}/distances`)
        const distances = Array.isArray(data) ? data : (data?.distances || [])
        this.distancesWithFiles = distances
        this.select_kinds_sport = distances
      } catch (e) {
        console.log(e)
      }
    },
    deleteRun(index) {
      this.runs.splice(index, 1)
      localStorage.setItem('runs', JSON.stringify(this.runs))
    },
    addRun() {
      this.runs.push({ name: '', time: '' })
      localStorage.setItem('runs', JSON.stringify(this.runs))
    },
    async getKindOfSports() {
      const data = await kindOfSports.fetchItems()
      this.kindOfSports = data.data && data.data.rows
    },
    async getSeasons() {
      const data = await seasons.fetchItems()
      this.seasons = data.data && data.data.rows
    },
    async getQuestions() {
      const data = await questions.fetchItems({
        start_id: this.$route.params.id,
      })
      if (data.data.questionList.length !== 0) {
        data.data.questionList.forEach(question => {
          this.memberFields.push({
            key: `${question.id}`,
            label: question.title,
          })
        })
      }
    },
    getUserAnswer(data) {
      if (!Number(data.field.key)) {
        return data.value
      }

      const currentQuestion = data.item.additional_field_answers.find(
        item => item.additionalFieldId === Number(data.field.key),
      )

      if (!currentQuestion) {
        return '-'
      }

      if (currentQuestion.bool !== null) {
        return currentQuestion.bool ? 'Да' : 'Нет'
      }
      if (currentQuestion.date) {
        return this.$moment(currentQuestion.date).format('DD.MM.YYYY')
      }
      if (currentQuestion.number) {
        return currentQuestion.number
      }
      if (currentQuestion.string) {
        return currentQuestion.string
      }
      if (currentQuestion.options) {
        return currentQuestion.options.map(item => item.title).join(', ')
      }
      return '-'
    },
    async deleteRegistration() {
      await memberModule
        .deleteItem(this.currentRegForDelete)
        .then(async () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Успешно',
              icon: 'BellIcon',
              text: 'Регистрация удалена успешно',
              variant: 'success',
            },
          })
          await this.getMembersFromStart()
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка',
              icon: 'BellIcon',
              text: error.response.data.message,
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.$refs['delete-modal'].hide()
        })
    },
    async deleteBulkRegistrations(bvModalEvt) {
      bvModalEvt.preventDefault()
      const ids = [...this.selectedGroups]
      if (ids.length === 0) {
        this.$refs['bulk-delete-modal'].hide()
        return
      }
      this.bulkDeleteLoading = true
      let succeeded = 0
      let failed = 0
      const errorMessages = []
      try {
        for (const id of ids) {
          try {
            await memberModule.deleteItem(id)
            succeeded += 1
          } catch (error) {
            failed += 1
            const msg = error.response?.data?.message
            if (msg && !errorMessages.includes(msg)) {
              errorMessages.push(msg)
            }
          }
        }
        if (succeeded > 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Успешно',
              icon: 'BellIcon',
              text:
                failed === 0
                  ? `Удалено регистраций: ${succeeded}`
                  : `Удалено: ${succeeded}, не удалось удалить: ${failed}`,
              variant: failed === 0 ? 'success' : 'warning',
            },
          })
          await this.getMembersFromStart()
          this.selectedGroups = []
        }
        if (failed > 0 && succeeded === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка',
              icon: 'BellIcon',
              text: errorMessages[0] || 'Не удалось удалить регистрации',
              variant: 'danger',
            },
          })
        } else if (failed > 0 && errorMessages.length > 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Часть операций завершилась с ошибкой',
              icon: 'BellIcon',
              text: errorMessages.join(' '),
              variant: 'warning',
            },
          })
        }
      } finally {
        this.bulkDeleteLoading = false
        this.$refs['bulk-delete-modal'].hide()
      }
    },
    async getCities() {
      const data = await cities.fetchItems()
      this.cities = data.data && data.data.rows
    },
    async successResultUpload(data) {
      const result = await this.$http
        .post('/member-result/bulk', {
          start_id: this.$route.params.id,
          results: data.results.map(e => {
            let circles = []
            for (const key in e) {
              if (key.indexOf('circle') === 0) {
                circles.push(e[key])
              }
            }
            circles = JSON.stringify(circles)
            return {
              ...e,
              circles,
              start_id: this.$route.params.id,
            }
          }),
        })
        .then(e => e.data)
      this.$refs.fileResultsComponent.refreshResults()
    },
    async getMembersFromStart() {
      const loadedCount = Math.max(
        this.members.length,
        this.skipCountMembers,
        this.maxResultCountMembers,
      )
      this.skipCountMembers = 0
      const payload = this.buildMembersPayload({
        skipCount: 0,
        maxResultCount: loadedCount,
      })
      await memberModule.fetchItems(payload).then(res => {
        this.members = res.data.rows
        this.skipCountMembers = this.members.length
      })
    },
    async refreshPaymentLink(member) {
      if (!member.price) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Предупреждение',
            icon: 'BellIcon',
            text: 'Необходимо установить цену участнику, чтобы сформировать ссылку на оплату',
            variant: 'warning',
          },
        })
        return false
      }
      if (!member.hasOwnProperty('disabled')) {
        this.$set(member, 'disabled')
      }
      member.disabled = true
      const result = await this.$http
        .put(`/member-start/${member.id}/repayment`)
        .then(r => r.data)
      if (result.payment.formUrl) {
        const data = [
          new ClipboardItem({
            'text/plain': new Blob([result.payment.formUrl], {
              type: 'text/plain',
            }),
          }),
        ]
        navigator.clipboard.write(data).then(
          () => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Скопировано',
                icon: 'BellIcon',
                text: 'Новая ссылка на оплату скопирована в буфер обмена',
                variant: 'success',
              },
            })
          },
          () => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка',
                icon: 'BellIcon',
                text: 'Невозможно поместить ссылку в буфер обмена',
                variant: 'warning',
              },
            })
            alert(result.payment.formUrl)
          },
        )
      }
      member.disabled = false
    },
    addResultLink() {
      this.start.results.push({
        name: '',
        file: null,
      })
    },
    async changePayment(status) {
      if (this.selectedGroups.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка',
            icon: 'BellIcon',
            text: 'Не выбраны группы',
            variant: 'danger',
          },
        })
        return false
      }

      await paymentModule
        .createItem({
          groupIds: this.selectedGroups,
          isPayed: status === 'paid',
        })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Уведомление',
              icon: 'BellIcon',
              text: 'Смена статуса оплаты прошла успешно',
              variant: 'success',
            },
          })
          this.getMembersFromStart()
          this.selectedGroups = []
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка',
              icon: 'BellIcon',
              text: 'Ошибка смены статуса оплаты',
              variant: 'danger',
            },
          })
        })
    },
    validateStart() {
      const errors = []

      if (!this.start.name?.trim()) {
        errors.push('Название старта обязательно для заполнения')
      }

      if (!this.start.city_id) {
        errors.push('Город проведения обязателен для заполнения')
      }

      if (
        !this.start.registration_start_date
        || !this.start.registration_end_date
        || !this.start.start_date
        || !this.start.end_date
      ) {
        errors.push("Необходимо заполнить все поля раздела - 'Программа старта'")
      }

      if (errors.length > 0) {
        errors.forEach(text => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка валидации',
              icon: 'AlertTriangleIcon',
              text,
              variant: 'danger',
            },
          })
        })
        return false
      }

      return true
    },
    getErrorMessage(error) {
      if (!error.response) {
        return 'Ошибка сети. Проверьте подключение к интернету'
      }

      const data = error.response?.data

      if (!data) {
        return `Неизвестная ошибка (HTTP ${error.response.status})`
      }

      if (Array.isArray(data.validator) && data.validator.length > 0) {
        return data.validator.map(v => [v.message].flat().join(', ')).join('; ')
      }

      if (data.errors) {
        if (Array.isArray(data.errors)) {
          return data.errors.map(e => e.message || e).join('; ')
        }
        if (typeof data.errors === 'object') {
          return Object.values(data.errors).flat().join('; ')
        }
      }

      return data.message || `Неизвестная ошибка (HTTP ${error.response.status})`
    },
    saveItem() {
      if (!this.validateStart()) {
        return
      }

      this.start.sponsors_list = []
      this.sponsors.forEach(sponsor => {
        if (sponsor.logo) {
          this.start.sponsors_list.push({
            ...sponsor,
            logo: JSON.stringify(sponsor.logo),
          })
        }
      })

      this.start.frame = this.schemeRouteIframe

      // schemeRouteFileId - источник истины для template_frame_image
      // Используем его напрямую, т.к. он обновляется при добавлении/удалении файла
      this.start.template_frame_image = this.schemeRouteFileId

      this.start.results_list = (this.start?.results || []).map(e => ({
        name: e.name,
        fileID: e.fileID,
      }))

      let errorNetworks = []
      this.organizers.forEach(item => {
        const errorOrgLinks = item.social_networks.filter(social => {
          if (!social.code) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка валидации',
                icon: 'AlertTriangleIcon',
                text: 'Укажите код социальной сети у одного из организаторов',
                variant: 'danger',
              },
            })
            return true
          }
          return !this.isExternalLink(social.url, social.code)
        })
        errorNetworks = errorNetworks.concat(errorOrgLinks)
      })

      const organizersDuplicateCheck = validateOrganizersNoDuplicates(this.organizers)
      if (!organizersDuplicateCheck.valid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка валидации',
            icon: 'AlertTriangleIcon',
            text: organizersDuplicateCheck.message,
            variant: 'danger',
          },
        })
        return
      }

      const errorLinks = this.socials.filter(social => {
        if (!social.code) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка валидации',
              icon: 'AlertTriangleIcon',
              text: 'Укажите код социальной сети в разделе «Полезные ссылки»',
              variant: 'danger',
            },
          })
          return true
        }
        return !this.isExternalLink(social.url, social.code)
      })
      errorNetworks = errorNetworks.concat(errorLinks)

      if (errorNetworks.length !== 0) {
        return
      }

      this.start.useful_links_list = this.useful_links
      this.start.social_networks_list = this.socials
      this.start.promocodes_list = this.promocodes.map(obj => {
        if (obj.template_id) {
          const { id, ...rest } = obj
          return rest
        }
        return obj
      })
      this.start.personal_discounts = this.personalDiscounts.map(obj => {
        if (obj.template_id) {
          const { id, ...rest } = obj
          return {
            ...rest,
            user_id: obj.user.id,
          }
        }
        return {
          ...obj,
          user_id: obj.user.id,
        }
      })
      this.start.kind_of_sports_list = this.kindOfSports_local
      this.start.distances_list = this.distanceMap(this.distancesWithFiles)

      delete this.start.results
      delete this.start.distances
      delete this.start.sponsors
      delete this.start.disabledDistances
      delete this.start.start_series_id
      delete this.start.start_archive_id
      delete this.start.archive
      delete this.start.series

      this.start.organizers_list = this.organizers.map((org, index) => {
        if (org.messengers) {
          return {
            ...org,
            messengers: org.messengers.join(','),
            social_networks_list: org.social_networks,
            photo_id: org.photo_id,
            organizer_is_main: index === this.mainOrganizerIndex,
          }
        }
        return {
          ...org,
          social_networks_list: org.social_networks,
        }
      })

      if (this.excelResultColumns.length > 0) {
        this.start.result_columns_json = JSON.stringify(this.excelResultColumns)
      } else {
        this.start.result_columns_json = null
      }

      this.start.criteria_list = this.allCriteria
        .filter(c => this.selectedCriteriaKeys.includes(c.title))
        .map(c => ({ title: c.title, description: c.description }))
      // criteria — поле, под которым сервер возвращает список критериев
      delete this.start.criteria

      if (this.$route.params.id === 'new') {
        this.createStart()
      } else {
        this.updateStart()
      }
    },
    distanceMap(distancesList) {
      return distancesList.map(distance => {
        const {
          slots,
          infinite_slots,
          static_price,
          stages,
          additional_fields,
          discounts,
          groups,
          date_prices,
          track_link,
          track_link_id,
          ...rest
        } = distance
        const mappedAdditionalFields = additional_fields?.map(field => ({
          ...field,
          options_list: field?.options,
        }))
        const mappedStages = stages?.map(stage => {
          const mappedStagesFields = stage?.additional_fields.map(field => ({
            ...field,
            options_list: field.options,
          }))
          return {
            ...stage,
            additional_fields_list: mappedStagesFields,
          }
        })

        const normalizedTrackLinkId = track_link_id
          ?? (typeof track_link === 'object' ? track_link?.id : track_link)
          ?? null

        const base = {
          static_price,
          track_link_id: normalizedTrackLinkId,
          additional_fields_list: mappedAdditionalFields,
          age_discounts_list: discounts,
          stages_list: mappedStages,
          groups_list: groups,
          date_prices_list: date_prices,
          infinite_slots,
          ...rest,
        }

        if (infinite_slots) return { ...base, slots: null }
        return { ...base, slots }
      })
    },
    async updateStart() {
      this.isloading = true
      const startId = this.start.id || +this.$route.params.id
      try {
        await startModule
          .updateItem(startId, this.start)
          .then(async () => {
            await this.updateDataFromStart()
            await this.getMembersFromStart()
            await this.getDistanceses()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Старт сохранен',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            const status = error.response?.status
            const message = status === 403 && this.isStartCompleted
              ? 'Сервер запрещает изменение завершённых стартов (403). Обратитесь к разработчикам бекенда.'
              : this.getErrorMessage(error)
            if (!error.notified || (status === 403 && this.isStartCompleted)) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Ошибка сохранения',
                  icon: 'AlertTriangleIcon',
                  text: message,
                  variant: 'danger',
                },
              })
            }
          })
          .finally(() => {
            this.isloading = false
          })
      } catch (e) {
        this.isloading = false
        if (!e.notified) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка сохранения',
              icon: 'AlertTriangleIcon',
              text: this.getErrorMessage(e),
              variant: 'danger',
            },
          })
        }
      }
    },
    async createStart() {
      this.isloading = true
      try {
        await startModule
          .createItem(this.start)
          .then(async response => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Старт добавлен',
                variant: 'success',
              },
            })
            await this.$router.push({
              name: 'start-page',
              params: { id: response.data.id },
              query: { tab: 'general' },
            })
            await this.updateDataFromStart()
            await this.getMembersFromStart()
            await this.getDistanceses()
          })
          .catch(error => {
            if (!error.notified) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Ошибка создания',
                  icon: 'AlertTriangleIcon',
                  text: this.getErrorMessage(error),
                  variant: 'danger',
                },
              })
            }
          })
          .finally(() => {
            this.isloading = false
          })
      } catch (e) {
        this.isloading = false
        if (!e.notified) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка создания',
              icon: 'AlertTriangleIcon',
              text: this.getErrorMessage(e),
              variant: 'danger',
            },
          })
        }
      }
    },
    async getAllStartSeries(params = {}) {
      try {
        this.isloading = true
        const response = await this.$http.get('start/start-series/all-series', {
          params,
        })
        this.allSeries = response.data
      } catch (error) {
        console.error('Ошибка при получении серий стартов:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка',
            icon: 'BellIcon',
            text: 'Не удалось загрузить серии стартов',
            variant: 'danger',
          },
        })
        throw error
      } finally {
        this.isloading = false
      }
    },
    async getAllStartArchives(params = {}) {
      try {
        const response = await this.$http.get('start/start-archive/all-archives', {
          params,
        })
        this.allArchives = response.data
        this.syncStartArchiveIdFromList(this.allArchives)
      } catch (error) {
        console.error('Ошибка при получении архивов:', error)
        this.allArchives = []
        if (error?.response?.status !== 404) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка',
              icon: 'BellIcon',
              text: 'Не удалось загрузить архивы',
              variant: 'danger',
            },
          })
        }
      }
    },
    syncStartArchiveIdFromList(archives) {
      if (!this.start || !this.startPageId) return
      const matched = (archives || []).find(archive =>
        (archive.starts || []).some(s => Number(s.id) === Number(this.startPageId)),
      )
      this.$set(this.start, 'start_archive_id', matched ? matched.id : null)
    },
    onStartArchiveChanged(archiveId) {
      if (!this.start) return
      this.$set(this.start, 'start_archive_id', archiveId != null ? archiveId : null)
    },
    debounceSearch(search, loading, fn) {
      clearTimeout(this.debounce)
      if (search.length >= 0) {
        this.debounce = setTimeout(fn, 600)
      }
    },
    onMembersSearchInput(value) {
      this.getFilteredMembers(value)
    },
    resetMembersInfiniteScroll() {
      this.membersInfiniteId += 1
      if (this.scrollState && typeof this.scrollState.reset === 'function') {
        this.scrollState.reset()
      }
    },
    getFilteredMembers(search) {
      const query = search == null ? '' : String(search)
      this.debounceSearch(query, null, async () => {
        try {
          this.skipCountMembers = 0
          this.members = []

          const payload = this.buildMembersPayload({
            skipCount: 0,
            maxResultCount: this.maxResultCountMembers,
          })
          const res = await memberModule.fetchItems(payload)
          const rows = (res.data && res.data.rows) || []
          this.members = [...rows]
          this.skipCountMembers = rows.length
          // Remount infinite-loading so it can fetch the next pages again
          this.resetMembersInfiniteScroll()
        } catch (e) {
          console.error(e)
        }
      })
    },
    getRowClass(item, type) {
      if (type === 'row') {
        // Проверяем, есть ли скрытые участники в группе
        const hasHiddenMembers = item.members && item.members.some(member => member.hidden)
        return hasHiddenMembers ? 'hidden-member-row' : ''
      }
      return ''
    },
    getMemberRowClass(item, type) {
      if (type === 'row') {
        const grey = this.isGreyParticipant(item)
        if (item.hidden && grey) return 'hidden-member-row grey-member-row'
        if (item.hidden) return 'hidden-member-row'
        if (grey) return 'grey-member-row'
        return ''
      }
      return ''
    },
    isGreyParticipant(member) {
      if (!member) return false
      const accountType = (member.participant && member.participant.account_type)
        || member.account_type
        || ''
      return String(accountType).toLowerCase() === 'grey' || String(accountType).toLowerCase() === 'gray'
    },
  },
}
</script>
<style scoped lang="scss">
.table-payment-row {
  display: flex;
  align-items: center;
}

.icons-container {
  display: flex;
  align-items: center;
  gap: 10px;

  .chevron-container {
    display: none;
  }

  .bi-chevron-down {
    cursor: pointer;
    margin: 0;
    transition: all 0.5s ease-out;

    path {
      fill: #6e6b7b;
    }
  }

  .rotate-chevron {
    transform: rotate(-180deg);
  }
}

.nav-bar {
  display: flex;
  align-items: center;
  margin: 0 -5px 10px -5px;

  &__item {
    font-size: 14px;
    font-weight: 500;
    padding: 8px 20px;
    border-radius: 5px;

    margin: 0 5px;
    color: #636363;
    transition: 0.3s;

    &:hover {
      transform: scale(1.05);
      cursor: pointer;
    }

    .dark-layout & {
      color: #ffffff;

      &.active {
        color: #ffffff;
      }
    }

    &.active {
      background: #7367f0;
      color: #ffffff;
    }
  }
}

.buttonsContainer {
  margin: 0 15px;
  justify-content: end;
  position: fixed !important;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  right: 0;
  bottom: 30px;
  z-index: 1000;

  .membersTabButtons {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
}

.fa-minus {
  path {
    fill: #b4b7bd;
  }
}

.flex-wrapper {
  display: flex;
}

.search-wrap {
  display: flex;
  justify-content: right;
}

.criterion-item {
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);

  &:last-child {
    border-bottom: none;
  }

  .custom-control-label {
    cursor: pointer;
  }
}

.criterion-content {
  display: inline;
}

.criterion-title {
  font-weight: 600;
}

.criterion-description {
  font-size: 0.875rem;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.b-table-details {
  td:first-child {
    padding: 0;
  }
}

.first-table {
  th {
    white-space: nowrap;
  }

  .b-table-has-details {
    background-color: #d1d0e8 !important;
  }

  tr {
    td {
      font-weight: 600;
    }
  }
}

.second-table {
  th {
    white-space: nowrap;
  }

  td:first-child {
    padding: 0.72rem 2rem;
  }

  tr {
    td {
      font-weight: 400;
    }
  }
}

// Стили для скрытых участников
.grey-member-row {
  background-color: rgba(255, 193, 7, 0.08);
}

.hidden-member-row {
  background-color: #f8f9fa !important;
  opacity: 0.7;

  td {
    background-color: #f8f9fa !important;
    color: #6c757d;
    font-style: italic;
  }

  &:hover {
    background-color: #e9ecef !important;

    td {
      background-color: #e9ecef !important;
    }
  }
}

.hidden-member-indicator {
  color: #dc3545;
  font-weight: bold;
  font-size: 0.875rem;
}

.dark-layout {
  .collapse-wrapper {
    background-color: #283046;
  }
}

.card {
  box-shadow: none;
}

.collapse-wrapper {
  background-color: #fff;
  padding: 21px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
  //
  h4 {
    margin-bottom: unset;
  }

  margin-bottom: 1rem;

  border-radius: 0.428rem;
}
</style>
